import React from "react";

import { LayoutContext } from "App/common/hoc/Layout/index";
import { NavLink } from "react-router-dom";

import { ReactComponent as CreditCardIcon } from "assets/images/app_svg/credit_card.svg";

function UpdateCC(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);

  const getPlanType = id => {
    if (id >= 100 && id <= 199) return "Personal";
    else if (id >= 200) return "Team";
  };

  return (
    <div className="updateCreditCard_header">
      <div className="plan">
        <p className="planType">
          <span>
            <b>Plan:</b> {getPlanType(props.planId)}{" "}
            <span className="totComputers">
              {" "}
              ({props.userLimit} {props.userLimit > 1 ? " Users" : " User"})
            </span>
          </span>
        </p>
        {/* 	<a class="btn blue" id="addHostHeader">Add / Remove Computer</a> */}
        <div
          className="card"
          onClick={() =>
            lMethods.openPopup("ccUpdateLayout", {
              execute: () => {
                lMethods.closePopup();
              },
              backButton: false
            })
          }
        >
          <CreditCardIcon />
          <a id="creditCard">Change Credit Card</a>
        </div>
        <NavLink
          to="/mirror/account/planOptions"
          className="btn blue"
          id="upgradeHeader"
        >
          Upgrade
        </NavLink>
      </div>
    </div>
  );
}

export default UpdateCC;
